
import React, { useState, useRef, useEffect } from 'react'
import { getProfilePic } from "../Helpers/Common";
import TextField from '@mui/material/TextField';
import { BgPostButton, PublishIcon, TextGray, TextGreen } from "../../pages/Theme";
import { MdOutlinePublic } from 'react-icons/md';
import Tooltip from '@mui/material/Tooltip';
import { IoMdLock } from 'react-icons/io';
import { useSelector } from 'react-redux';
import { FiSend } from 'react-icons/fi';

const CommentInput = ({ comment, setComment, commentPost, profilePhoto }) => {

    const [isPublic, setIsPublic] = useState(true);
    const userProfile = useSelector((state) => state.auth.user);

    const handlePrivatePublic = (data) => {
        if (isPublic != data) {
            setIsPublic(!isPublic);
        }
    }

    const handlePost = () => {
        commentPost(comment, isPublic)
        setIsPublic(true);
    }
    const textareaRef = useRef(null);

    // Auto-resize textarea
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 100)}px`;
        }
    }, [comment]);
    return (
        <div className="flex flex-row my-2 relative gap-2" onClick={e => e.stopPropagation()}>
            <div className='flex items-center'>
                <img className="h-9 w-9 rounded-full" src={getProfilePic(userProfile?.photo)} alt="profile"></img>
            </div>
            <div className="relative border rounded-md px-4 py-2 w-full bg-white">
                <textarea
                    ref={textareaRef}
                    rows={1}
                    className="w-full resize-none bg-transparent text-sm placeholder-gray-500 focus:outline-none pr-16"
                    placeholder="Type your comment here"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    style={{ maxHeight: '100px', minHeight: '40px' }}
                />

                {/* Icons at bottom right */}
                <div className="absolute right-3 bottom-2 flex items-center space-x-2 bg-white">
                    {isPublic ? (
                        <Tooltip title="Click to switch to private comment" placement="top" arrow>
                            <span>
                                <MdOutlinePublic
                                    className="w-6 h-6 cursor-pointer primaryIcon"
                                    onClick={() => handlePrivatePublic(false)}
                                />
                            </span>
                        </Tooltip>
                    ) : (
                        <Tooltip title="Click to switch to public comment" placement="top" arrow>
                            <span>
                                <IoMdLock
                                    className="w-6 h-6 cursor-pointer secondaryIcon"
                                    onClick={() => handlePrivatePublic(true)}
                                />
                            </span>
                        </Tooltip>
                    )}
                    <Tooltip title="Add comment" placement="top" arrow>
                        <button
                            onClick={() => handlePost()}
                            className="focus:outline-none chatBotSentIcon"
                        >
                            <FiSend className="w-4 h-4 pr-0.5 text-white" />
                        </button>
                    </Tooltip>
                </div>
            </div>
            {/* <TextField
                className="bg-gray pr-2"
                id="outlined-multiline-flexible"
                style={{ width: '100%' }}
                sx={{
                    '& .MuiInputBase-input': {
                        paddingRight: '10px !important',
                    },
                }}
                multiline
                placeholder='add comment...'
                value={comment}
                onChange={e => setComment(e.target.value)}
            /> */}
            {/* {isPublic == true ?
                <Tooltip title={"Click to switch to private comment"} className='z-50 -ml-7' placement="top" arrow>
                    <PublishIcon className='z-50'>
                        <MdOutlinePublic className='w-6 h-6 z-50 mt-1.5' onClick={() => handlePrivatePublic(false)} />
                    </PublishIcon>
                </Tooltip> :
                <Tooltip title={"Click to switch to public comment"} className='z-50 -ml-7' placement="top" arrow>
                    <TextGray className='z-50'>
                        <IoMdLock className='w-6 h-6 z-50 mt-1.5' onClick={() => handlePrivatePublic(true)} />
                    </TextGray>
                </Tooltip>} */}
            {/* <button 
                className="rounded-full px-3 lg:px-7 xl:px-10 h-full lg:py-3 bg-blue text-sm md:text-base font-semibold text-white cursor-pointer absolute right-0 top-0"
                onClick={() => commentPost(comment)}
            >
                Post
            </button> */}
            {/* <BgPostButton
                className="rounded-full ml-1 px-3 lg:px-7 xl:px-10 h-full lg:py-3 text-sm md:text-base font-semibold cursor-pointer right-0 top-0 hover:opacity-80"
                onClick={() => handlePost()}
            >
                Post
            </BgPostButton> */}

        </div>
    )
}

export default CommentInput
